"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.COMPLETE_TXT=void 0;var COMPLETE_TXT="Terminé";exports.COMPLETE_TXT=COMPLETE_TXT;